import { WifiOff } from "lucide-react";
import { useOnline } from "../hooks/usePWA";

// Global banner shown whenever the device loses connectivity.
export default function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div
      data-testid="offline-banner"
      className="sticky top-0 z-[70] bg-amber-500 text-white text-sm font-medium px-4 py-2 flex items-center justify-center gap-2 text-center"
    >
      <WifiOff className="h-4 w-4 shrink-0" />
      You're offline — you can browse, but creating or exporting documents needs a connection.
    </div>
  );
}
